import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author?: string; // Optional if not provided in copy, but good to have structure
}
export function TestimonialCard({
  quote,
  author
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 flex flex-col h-full" data-id="element-207">
      <div className="flex gap-1 mb-4" data-id="element-208">
        {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-209" />)}
      </div>
      <blockquote className="text-gray-700 italic text-lg mb-4 flex-grow" data-id="element-210">
        "{quote}"
      </blockquote>
      {author && <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-211">
          <p className="font-bold text-gray-900" data-id="element-212">{author}</p>
        </div>}
    </div>;
}